import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Iniciales para un avatar a partir de un nombre completo (p. ej. para Topbar y Usuarios).
export function iniciales(nombre: string): string {
  const partes = nombre.trim().split(/\s+/).filter(Boolean);
  if (!partes.length) return 'U';
  return (partes[0][0] + (partes[1]?.[0] ?? '')).toUpperCase();
}

// Color de avatar determinístico por id (no aleatorio): ayuda a distinguir filas en
// una lista larga sin depender de una imagen real. Usado por Usuarios/CrearUsuario.
const PALETA_AVATAR = [
  'bg-emerald-100 text-emerald-700',
  'bg-teal-100 text-teal-700',
  'bg-blue-100 text-blue-700',
  'bg-amber-100 text-amber-700',
  'bg-rose-100 text-rose-700',
  'bg-violet-100 text-violet-700',
];
export function colorAvatar(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) % PALETA_AVATAR.length;
  return PALETA_AVATAR[Math.abs(h) % PALETA_AVATAR.length];
}
